"use strict";
exports.__esModule = true;
exports.ButtonIcon = void 0;
var ButtonIcon;
(function (ButtonIcon) {
    ButtonIcon["ADD"] = "add";
    ButtonIcon["ARROW_DOWN"] = "arrowDown";
    ButtonIcon["MEATBALLS"] = "meatballs";
    ButtonIcon["DELETE"] = "delete";
    ButtonIcon["FILTER"] = "filter";
})(ButtonIcon = exports.ButtonIcon || (exports.ButtonIcon = {}));
